<template>
    <div class="wrapper-body flex-1">
        <ListCorrespondences :nodeId="nodeId" :selectionMode="'multi'" />
    </div>
</template>

<script>
    import ListCorrespondences from '@/components/ListCorrespondences.vue';

	export default {
		name: 'InboxView',
        components: { ListCorrespondences },
        data () 
        {
            return {
                nodeId: 1,
            }
        },
        mounted () 
        {
            this.nodeId = 1
        },
	}
</script>